module.exports = __webpack_public_path__ + "img/book_active.e822ab3d.svg";